/**
 * League tier levels for the ranking system
 * Ordered from lowest to highest
 */
export type LeagueTier = 'NOVATO' | 'AVANZADO' | 'EXPERTO' | 'MAESTRO' | 'LEYENDA';

export const LEAGUE_TIERS: LeagueTier[] = [
  'NOVATO',
  'AVANZADO',
  'EXPERTO',
  'MAESTRO',
  'LEYENDA',
];

export interface LeagueTierConfig {
  name: string;
  description: string;
  icon: string;
  color: string;
  bgColor: string;
  darkBgColor: string;
  minXP: number;
}

export const LEAGUE_TIER_CONFIG: Record<LeagueTier, LeagueTierConfig> = {
  NOVATO: {
    name: 'Novato',
    description: 'Liga inicial para nuevos estudiantes',
    icon: '🥉',
    color: '#CD7F32',
    bgColor: 'bg-amber-100',
    darkBgColor: 'dark:bg-amber-900/30',
    minXP: 0,
  },
  AVANZADO: {
    name: 'Avanzado',
    description: 'Para estudiantes con experiencia',
    icon: '🥈',
    color: '#C0C0C0',
    bgColor: 'bg-gray-200',
    darkBgColor: 'dark:bg-gray-700/50',
    minXP: 500,
  },
  EXPERTO: {
    name: 'Experto',
    description: 'Liga para estudiantes dedicados',
    icon: '🥇',
    color: '#FFD700',
    bgColor: 'bg-yellow-100',
    darkBgColor: 'dark:bg-yellow-900/30',
    minXP: 2000,
  },
  MAESTRO: {
    name: 'Maestro',
    description: 'Liga de élite',
    icon: '💎',
    color: '#B9F2FF',
    bgColor: 'bg-cyan-100',
    darkBgColor: 'dark:bg-cyan-900/30',
    minXP: 5000,
  },
  LEYENDA: {
    name: 'Leyenda',
    description: 'Los mejores de los mejores',
    icon: '👑',
    color: '#9333EA',
    bgColor: 'bg-purple-100',
    darkBgColor: 'dark:bg-purple-900/30',
    minXP: 10000,
  },
};

export function getLeagueTierConfig(tier: LeagueTier): LeagueTierConfig {
  return LEAGUE_TIER_CONFIG[tier];
}

export function getLeagueTierName(tier: LeagueTier): string {
  return LEAGUE_TIER_CONFIG[tier].name;
}

export function getLeagueTierIcon(tier: LeagueTier): string {
  return LEAGUE_TIER_CONFIG[tier].icon;
}

export function getLeagueTierColor(tier: LeagueTier): string {
  return LEAGUE_TIER_CONFIG[tier].color;
}

export function getNextTier(tier: LeagueTier): LeagueTier | null {
  const currentIndex = LEAGUE_TIERS.indexOf(tier);
  return currentIndex < LEAGUE_TIERS.length - 1 ? LEAGUE_TIERS[currentIndex + 1] : null;
}

export function getPreviousTier(tier: LeagueTier): LeagueTier | null {
  const currentIndex = LEAGUE_TIERS.indexOf(tier);
  return currentIndex > 0 ? LEAGUE_TIERS[currentIndex - 1] : null;
}

export function isTopTier(tier: LeagueTier): boolean {
  return tier === 'LEYENDA';
}

export function isBottomTier(tier: LeagueTier): boolean {
  return tier === 'NOVATO';
}
